import React, { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';

const PaymentFailedPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const campaignSlug = searchParams.get('campaign') || '';
  const isInIframe = typeof window !== 'undefined' && window.parent !== window;
  const notifiedRef = useRef(false);

  useEffect(() => {
    if (!isInIframe || notifiedRef.current) return;
    notifiedRef.current = true;
    const payload: Record<string, string> = {};
    searchParams.forEach((v, k) => { payload[k] = v; });
    try {
      window.parent.postMessage({ type: 'amutech-payment-failed', payload }, '*');
    } catch {}
  }, [isInIframe, searchParams]);

  if (isInIframe) {
    return (
      <div dir="rtl" className="min-h-screen flex items-center justify-center bg-white">
        <div className="text-center">
          <div style={{ fontSize: 56, marginBottom: 12 }}>😔</div>
          <p className="text-red-600 font-semibold">התשלום לא הושלם</p>
        </div>
      </div>
    );
  }

  return (
    <div dir="rtl" className="min-h-screen flex items-center justify-center px-4" style={{ background: 'linear-gradient(135deg, #fef2f2, #fff1f2)' }}>
      <div className="text-center w-full max-w-md py-10 px-4">
        <div style={{ fontSize: 72, marginBottom: 16 }}>😔</div>
        <h1 className="text-2xl md:text-4xl font-black text-red-600 mb-3">התשלום לא הושלם</h1>
        <p className="text-base md:text-lg text-gray-600 leading-relaxed mb-2">משהו השתבש בתהליך התשלום.</p>
        <p className="text-sm text-gray-400 mb-8">אפשר לנסות שוב או ליצור קשר לעזרה.</p>
        <div className="flex flex-wrap gap-3 justify-center">
          {campaignSlug && (
            <a href={`/campaign/${campaignSlug}`}
              className="px-7 py-3.5 rounded-xl bg-red-600 text-white font-bold text-base no-underline hover:bg-red-700 transition-colors">
              ← נסה שוב
            </a>
          )}
          <a href="/"
            className="px-7 py-3.5 rounded-xl bg-white text-gray-700 font-semibold text-base no-underline border-2 border-gray-200 hover:bg-gray-50 transition-colors">
            לדף הבית
          </a>
        </div>
      </div>
    </div>
  );
};

export default PaymentFailedPage;
